

import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCapitalize]'
})
export class CapitalizeDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let value = this.el.nativeElement.value;
    if (value && value.length > 0) {
      // Capitalize the first letter
      this.el.nativeElement.value = value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
}

